<template>
    <div class="contracts">
        <div v-if="!loading">
            <p v-if="selectedJob && selectedJob.contracts && selectedJob.contracts.length">Contratos ({{selectedJob.contracts.length}})</p>
            <div class="list" v-if="selectedJob && selectedJob.contracts && selectedJob.contracts.length">
                <Contract :contract="contract" :key="contract.id" v-for="contract in selectedJob.contracts" />
            </div>
            <div v-else class="contracts-empty">
                <img src="/static/images/search.svg" alt="Procurando oportunidades">
                <p>Nenhum contrato pré-existente encontrado!</p>
            </div>
        </div>
        <div class="contracts-loading" v-else>
            <v-progress-circular
                :size="30"
                :width="4"
                color="blue"
                indeterminate
            ></v-progress-circular>
        </div>
    </div>
</template>

<script>
import Contract from '../Contract.vue';

export default {
    components: { Contract },

    props: {
        selectedJob: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
}
</script>

<style scoped>
    p {
        margin: 0;
    }
    .contracts {
        width: 100%;
        display: flex;
        flex-direction: column;
        /* box-shadow: 0 5px 20px 0 rgba(0,0,0, 0.15); */
        padding: 15px;
        border-radius: 5px;
        background-color: var(--white-color);
        gap: 10px;
        flex: 1;
    }

    .contracts > div > p {
        font-size: 18px;
        color: var(--primary-color);
        font-weight: bold;
        margin-bottom: 15px;
    }

    .list {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .contracts-empty {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: start;
        padding: 20px;
    }

    .contracts-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .contracts-empty img {
        width: 75px;
        height: 75px;
    }

    .contracts-empty p {
        font-size: 18px;
        color: var(--primary-color);
        font-weight: bold;
        margin-left: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/ContractsCard.vue